export default "__VITE_ASSET__063e0980__"